import { _T } from '../../../../../base-react/src/Localization';
import { apis, models } from "@vote4dance/judging-sdk";
var Api = apis.Api;
var ScheduleSource = models.schedules.ScheduleSource;
var FloorSource = models.floors.FloorSource;
var ScreenSource = models.screens.ScreenSource;
var CafeCompetitionProductsSource = models.cafe.CafeCompetitionProductsSource;
export const bootstrapCompetitionDefaults = async ({ competitionId, dateMode, startDate, endDate, dateFormat }) => {
    const extractCreatedId = (response, idKey, entityName) => {
        if (typeof response === 'string' || typeof response === 'number') {
            return String(response);
        }
        if (response && typeof response === 'object' && response[idKey] != null) {
            return String(response[idKey]);
        }
        throw new Error(`${entityName} create did not return ${idKey}`);
    };
    const createdFloorResponse = await Api.create(FloorSource(competitionId).url, {
        floor_name: _T('floor.main'),
        floor_code: null
    });
    const floorId = extractCreatedId(createdFloorResponse, 'floor_id', 'Floor');
    await Api.create(ScreenSource(competitionId).url, {
        screen_label: _T('screen.title'),
        screen_url: '',
        screen_target: '0'
    });
    const defaultCafeProducts = [
        _T('cafe.products.defaults.water'),
        _T('cafe.products.defaults.coffee'),
        _T('cafe.products.defaults.fruit'),
        _T('cafe.products.defaults.candy')
    ];
    for (const productName of defaultCafeProducts) {
        await Api.create(CafeCompetitionProductsSource(competitionId).url, {
            product_name: productName,
            product_status: 'active',
            product_price: 0,
            product_currency: 'sek'
        });
    }
    const scheduleUrl = ScheduleSource(competitionId).url;
    const suggestions = _T('schedule.suggestions')
        .split(',')
        .map((name) => name.trim())
        .filter((name) => name.length > 0);
    let firstScheduleId;
    let firstDayLastScheduleId;
    const setFirstScheduleId = (scheduleId) => {
        if (!firstScheduleId && scheduleId) {
            firstScheduleId = scheduleId;
        }
    };
    const createDefaultScheduleItems = async (setStartTimeAtNine = false) => {
        let lastCreatedScheduleId;
        for (const [index, name] of suggestions.entries()) {
            const scheduleStartTime = setStartTimeAtNine
                ? (index === 0 ? '08:00:00' : index === 1 ? '09:00:00' : undefined)
                : undefined;
            const createdScheduleResponse = await Api.create(scheduleUrl, {
                schedule_value: name,
                schedule_type: index === 0 ? 'comment' : 'label',
                schedule_start_time: scheduleStartTime
            });
            const createdScheduleId = extractCreatedId(createdScheduleResponse, 'schedule_id', 'Schedule item');
            setFirstScheduleId(createdScheduleId);
            lastCreatedScheduleId = createdScheduleId;
        }
        return lastCreatedScheduleId;
    };
    if (dateMode === 'multi' && startDate && endDate) {
        let currentDay = startDate.startOf('day');
        const lastDay = endDate.startOf('day');
        const competitionStartDate = startDate.format(dateFormat);
        while (!currentDay.isAfter(lastDay, 'day')) {
            const weekdayName = currentDay.format('dddd');
            const capitalizedWeekday = weekdayName
                ? `${weekdayName.charAt(0).toLocaleUpperCase()}${weekdayName.slice(1)}`
                : weekdayName;
            const currentDate = currentDay.format(dateFormat);
            const breakPayload = {
                schedule_value: capitalizedWeekday,
                schedule_type: 'break',
                schedule_date: currentDate
            };
            if (currentDate === competitionStartDate) {
                breakPayload.schedule_start_time = '07:00:00';
            }
            const createdBreakResponse = await Api.create(scheduleUrl, {
                ...breakPayload
            });
            const createdBreakId = extractCreatedId(createdBreakResponse, 'schedule_id', 'Schedule break');
            setFirstScheduleId(createdBreakId);
            const isCompetitionStartDay = currentDate === competitionStartDate;
            const createdDayLastScheduleId = await createDefaultScheduleItems(isCompetitionStartDay);
            if (!firstDayLastScheduleId) {
                firstDayLastScheduleId = createdDayLastScheduleId || createdBreakId;
            }
            currentDay = currentDay.add(1, 'day');
        }
    }
    else {
        let createdBreakScheduleId;
        if (startDate) {
            const weekdayName = startDate.format('dddd');
            const capitalizedWeekday = weekdayName
                ? `${weekdayName.charAt(0).toLocaleUpperCase()}${weekdayName.slice(1)}`
                : weekdayName;
            const createdBreakResponse = await Api.create(scheduleUrl, {
                schedule_value: capitalizedWeekday,
                schedule_type: 'break',
                schedule_date: startDate.format(dateFormat),
                schedule_start_time: '07:00:00'
            });
            const createdBreakId = extractCreatedId(createdBreakResponse, 'schedule_id', 'Schedule break');
            setFirstScheduleId(createdBreakId);
            createdBreakScheduleId = createdBreakId;
        }
        const createdDayLastScheduleId = await createDefaultScheduleItems(true);
        firstDayLastScheduleId = createdDayLastScheduleId || createdBreakScheduleId;
    }
    return {
        floorId,
        firstScheduleId,
        firstDayLastScheduleId
    };
};
